export default __webpack_public_path__ + "static/small-noise-min-9cf22f536c535e3b1479d34449ed8efd.png";